/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmPovolenySpisovyUzelFunkce extends GContentBase<SeznamAdmPovolenySpisovyUzelFunkceObj> {
        private seznamObj: SeznamAdmPovolenySpisovyUzelFunkceObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmPovolenySpisovyUzelFunkceObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmPovolenySpisovyUzelFunkceNew",
                contentCaption: "jres:33001027", //RC 33001027 : Vedlejší spisové uzly funkčních míst 
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_fun_txt} - {ixs_su_txt}"
                },
                gridSettings: {
                    columnOrder: this.getColumnOrder(),
                    profiles: [
                        {
                            name: "jres:33001041", //RC 33001041 : Podle funkčních míst
                            grouping: "ixs_fun_txt"
                        },
                        {
                            name: "jres:33001042", //RC 33001042 : Podle spisových uzlů
                            grouping: "ixs_su_txt"
                        }
                    ]
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }

        private getColumnOrder(): string {
            let columnOrder = "";
            if (this.ixs_fun)
                columnOrder += "ixs_su_txt,lic_adr_txt,"
            else if (this.ixs_su)
                columnOrder += "ixs_fun_txt,ixs_ref_txt,"
            else {
                columnOrder += "ixs_fun_txt,ixs_ref_txt,ixs_su_txt,lic_adr_txt,"
            }
            columnOrder += "vazba_txt,dat_zmena,zmenu_prov_txt";
            return columnOrder;
        }
    }

    export class SeznamAdmPovolenySpisovyUzelFunkceObj extends GAdmSeznamBase {
        ixs_su: string;
        ixs_fun: string;

        private openFromFunkcniMisto() {
            return this.ixs_fun ? true : false
        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmPovolenySpisovyUzelFunkce", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openFromFunkcniMisto: this.openFromFunkcniMisto(),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmPovolenySpisovyUzelFunkce",
                newRecord: isNew,
                ixs_su: isNew == true ? (this.ixs_su ? this.ixs_su : null) : data.ixs_su,
                ixs_fun: isNew == true ? (this.ixs_fun ? this.ixs_fun : null) : data.ixs_fun
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actHromadnaOperaceNew: {
                    caption: "jres:33001039", //RC 33001039 : Nové záznamy hromadně
                    icon: "gi-plus",
                    enabled: this.dataListDescription.data_right?.Create == true,
                    run: (ev, ctx) => {
                        this.hromadnaOperaceNew();
                    }
                },
                actEditHromadne: {
                    caption: "jres:33001040", //RC 33001040 : Upravit hromadně
                    icon: "gi-pencil",
                    enabled: this.dataListDescription.data_right?.Write ?? false,
                    run: (ev, ctx) => {
                        this.editHromadne();
                    }
                },
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                {
                    favorite: true,
                    action: this.cnt.actions.actNewDetail,
                    children: [
                        { action: this.cnt.actions.actHromadnaOperaceNew }
                    ]
                },
                "actEditHromadne*",
                "actAddToComparison*"
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            let typ_vazby = [
                { typ_vazby_txt: "jres:33001033", typ_vazby: 1 }, //RC 33001033 : Hlavní
                { typ_vazby_txt: "jres:33001034", typ_vazby: 0 },  //RC 33001034 : Vedlejší
            ]

            this.filterForm.addRow("jres:32131054").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                name: "ixs_fun",
                model: "model.ixs_fun=value.ixs_fun",
                dropdown: true,
                disabled: (this.ixs_fun) ? true : false
            }).addRow("jres:29930955").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), { //RC 33000888 : Skupina funkcí
                name: "ixs_su",
                model: "model.ixs_su=value.ixs_su",
                dropdown: true,
                disabled: (this.ixs_su) ? true : false
            }).addRow("jres:33001032").addField("gselectbox", { //RC 33001032 : Typ vazby
                name: "typ_vazby",
                dropdown: true,
                model: function (op, dto, opt) {
                    switch (op) {
                        case "apply":
                            var index = typ_vazby.findIndex(item => item.typ_vazby == dto.typ_vazby);
                            if (index >= 0) 
                                $(this).gfield("setValue", typ_vazby[index])
                            break;
                        case "collect":
                            let typ = $(this).gfield("getValue");
                            if (typ)
                                dto.typ_vazby = typ.typ_vazby;
                            break;
                    }
                },
                itemTemplate: "{typ_vazby_txt}",
                data: typ_vazby
            }) 
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_su)
                hardFilter["ixs_su"] = this.ixs_su;
            if (this.ixs_fun)
                hardFilter["ixs_fun"] = this.ixs_fun;
            hardFilter["typ_vazby"] = 0;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_su)
                data["ixs_su"] = this.ixs_su;
            if (this.ixs_fun)
                data["ixs_fun"] = this.ixs_fun;
        }

        applydata(filterData: any) {
            this.cnt.beginOperation();
            this.cnt.isl.AdmPovolenySpisovyUzelFunkce.list({ filters: filterData }).getView().then((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            }).always(() => { this.cnt.endOperation() })
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            var select = objArr.getSelection();
            if (select.length == 1)
                this.cnt.actions.actOpenDetail?.update({ enabled: this.row.length == 1 && select[0].vazba == 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_fun}#${data.ixs_su}#`,
                nazev: `${data.ixs_fun_txt} - ${data.ixs_su_txt}`
            }
        }

        rowsEnabledFunction(row: any): boolean {
            if (row.data.vazba == 1)
                return false;
            return true;
        }

        rowsCheckEnabledFunction(row: any): boolean {
            if (row.data.vazba == 1)
                return false;
            return true;
        }

        private hromadnaOperaceNew() {
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmPovolenySpisovyUzelFunkce"], { ID: "HromadnaOperaceAdmPovolenySpisovyUzelFunkce", data: [], povolEmpty: true }, "", 1000, 600).on("close", (ev, retValue) => {
                if (retValue == true)
                    this.applydata(this.filterData);
            })
        }

        private editHromadne() {
            var selection = this.grid.ggrid("getSelection");
            var defineData: any[] = [];
            selection.forEach((item) => {
                item.aktivita_txt = this.getAktivitaTxt(item.aktivita);
                item.lic_adr = item["lic_adr_txt"];
                item.ixs_fun_ref_txt = `${item["ixs_fun_txt"]} - ${item["ixs_ref_txt"]}`,
                item.update_exist = true;
                defineData.push(item);
            })
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmPovolenySpisovyUzelFunkce", { editData: defineData }], { ID: "HromadnaOperaceAdmPovolenySpisovyUzelFunkce", data: [], editMode: true }, "", 1000, 600).on("close", (ev, retValue) => {
                if (retValue == true)
                    this.applydata(this.filterData);
            })
        }

        updateGridFormat(gridFormat: Gordic.Data.GridFormat<any>): Gordic.Data.GridFormat<any> {
            this.settingGroupingColumn("ixs_fun_txt", true);
            this.settingGroupingColumn("ixs_su_txt", true);
            return gridFormat;
        }
    }
}